import { render, staticRenderFns } from "./invadjust.vue?vue&type=template&id=6245b2c2"
import script from "./invadjust.vue?vue&type=script&lang=js"
export * from "./invadjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports